import { RegisterSurgicalOrder } from 'domain/usecases/surgical-order/register-surgical-order'
import { SurgicalOrderRepository } from 'repository/interfaces/surgical-order-repository'

export class RemoteRegisterSurgicalOrder implements RegisterSurgicalOrder {
  constructor(
    private readonly surgicalOrderRepository: SurgicalOrderRepository
  ) {}

  add(
    params: RegisterSurgicalOrder.Params,
    profile?: 'secretary' | 'crmo'
  ): Promise<RegisterSurgicalOrder.Model> {
    if (profile === 'crmo') {
      return this.surgicalOrderRepository.registerCrmoSurgicalOrder(params)
    } else {
      return this.surgicalOrderRepository.registerSecretarySurgicalOrder(params)
    }
  }
}

export type RegisterSurgicalOrderModel = RegisterSurgicalOrder.Model
